'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class;

// Decorators


// Components


// Actions


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _ElementDropTarget = require('../../../element/dnd/ElementDropTarget');

var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);

var _Tool = require('../Tool');

var _Tool2 = _interopRequireDefault(_Tool);

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _PopupPanel = require('../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _selectionActions = require('../../../element/selection/selectionActions');

var _popupActions = require('../../../components/popupPanel/popupActions');

var _boardConstants = require('../../../../common/boards/boardConstants');

var _elementConstants = require('../../../../common/elements/elementConstants');

require('./Trash.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        deselectAllElements: function deselectAllElements() {
            return dispatch((0, _selectionActions.deselectAllElements)());
        },
        showTooltip: function showTooltip() {
            return dispatch((0, _popupActions.openPopup)('tooltip-trash'));
        }
    };
};

var trashDropTargetHandler = function trashDropTargetHandler(props, monitor, component) {
    props.deselectAllElements();

    var _monitor$getItem = monitor.getItem(),
        draggedElementIds = _monitor$getItem.draggedElementIds;

    return {
        acceptedElementIds: draggedElementIds,
        location: {
            parentId: '' + props.currentBoardId + _boardConstants.BOARD_ID_TRASH_APPEND,
            section: _boardConstants.BOARD_SECTIONS.TRASH,
            position: {
                addedDate: new Date().getTime()
            }
        },
        handledBy: _reactDom2.default.findDOMNode(component)
    };
};

var Trash = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec2 = (0, _ElementDropTarget2.default)({ drop: trashDropTargetHandler }, _elementConstants.DROP_TARGET_TYPES.TRASH), _dec(_class = _dec2(_class = function (_React$Component) {
    _inherits(Trash, _React$Component);

    function Trash() {
        _classCallCheck(this, Trash);

        return _possibleConstructorReturn(this, (Trash.__proto__ || Object.getPrototypeOf(Trash)).apply(this, arguments));
    }

    _createClass(Trash, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                isHovered = _props.isHovered,
                connectDropTarget = _props.connectDropTarget,
                showTooltip = _props.showTooltip;

            return connectDropTarget(_react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('Trash', { hover: isHovered }) },
                _react2.default.createElement(
                    _Tool2.default,
                    _extends({}, this.props, { name: 'Trash', isDragging: false, handleClick: showTooltip }),
                    _react2.default.createElement(
                        'div',
                        { className: 'icon' },
                        _react2.default.createElement(_Icon2.default, { name: 'toolbar-trash' })
                    ),
                    _react2.default.createElement(
                        _PopupPanel2.default,
                        { className: 'tooltip',
                            popupId: 'tooltip-trash',
                            arrowDir: 'left',
                            duration: 4000,
                            fadeIn: true },
                        _react2.default.createElement(
                            'span',
                            null,
                            'Drag something here to delete it'
                        )
                    )
                )
            ));
        }
    }]);

    return Trash;
}(_react2.default.Component)) || _class) || _class);


Trash.propTypes = {
    connectDropTarget: _propTypes2.default.func,
    deselectAllElements: _propTypes2.default.func,
    isHovered: _propTypes2.default.bool,
    currentBoardId: _propTypes2.default.string,
    showTooltip: _propTypes2.default.func
};

exports.default = Trash;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/elementTools/Trash.js
// module id = 2221
// module chunks = 0